import styled from 'styled-components'
import { FC } from 'react'

type Sizes = 'S' | 'M'

interface IProps {
  size?: Sizes
}

const fontBySize: Record<Sizes, string> = {
  M: 'var(--typography-12-16-bold)',
  S: 'var(--typography-11-16-normal)',
}

export const Wrapper = styled.span<{ $size: Sizes }>`
  color: var(--color-night);
  font: ${props => fontBySize[props.$size]};
`

const NoData: FC<IProps> = ({ size = 'M' }) => {
  return <Wrapper $size={size}>&ndash;</Wrapper>
}

export default NoData
